import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { ApolloError } from 'apollo-client';
import RewardIcon from '../../../components/RewardIcon';
import LoadingIndicator from '../../../components/LoadingIndicator/index';
import Moment from 'react-moment';
import moment from 'moment';
import 'moment-timezone';
import gql from 'graphql-tag';
import './ProfileRewardsList.css';

class ProfileRewardsList extends Component {
  renderReward(reward, index) {
    // substract one second to round dates that expire at midnight
    const rewardEndDate = moment(reward.endDate).subtract(1, 'second');
    const rewardStartDate = moment(reward.startDate);
    const warningMs = moment.duration(7 * 24 * 60 * 60 * 1000);

    let now = moment();
    let timeClass = '';
    if (rewardEndDate.isBefore(now)) {
      timeClass = 'expired';
    } else if (rewardStartDate.isBefore(now)) {
      if (
        rewardEndDate
          .clone()
          .subtract(warningMs)
          .isAfter(now)
      ) {
        timeClass = 'running';
      } else {
        timeClass = 'expiring';
      }
    } else {
      timeClass = 'pending';
    }

    let actionElement = null;
    /*if (
      reward.prizeType === REWARD_TYPE.HOTEL_STAY &&
      timeClass !== 'expired'
    ) {
      actionElement = (
        <Link to="/rewards" className="action-button btn btn-success">
          Book Now
        </Link>
      );
    }*/

    return (
      <div className={`reward-row ${timeClass}`} key={index}>
        <div className="reward-offer">
          <RewardIcon type={reward.prizeType} showTitle={true} />
        </div>
        <div className="reward-desc">{reward.prizeName}</div>
        <div className="reward-dates">
          <div className="reward-starts">
            <Moment interval={0} format="MM/DD/YY">
              {rewardStartDate}
            </Moment>
          </div>
          <div className="reward-ends">
            <Moment interval={0} format="MM/DD/YY">
              {rewardEndDate}
            </Moment>
          </div>
          {actionElement}
        </div>
      </div>
    );
  } // const renderReward = function(reward, index)

  render() {
    const { rewards, loading, error } = this.props.data;

    if (loading) {
      return <LoadingIndicator expand />;
    } else if (error) {
      return (
        <div className="profile-rewards-list">
          {/*use this class to bump to top of area*/}
          <div className="alert alert-danger">Failed to retreive rewards.  If this continues, please contact support.</div>
        </div>
      );
    } else {
      var sortedRewards = rewards.concat(); // de-const for sorting
      sortedRewards.sort(function(left, right) {
        // sort actives on endDate
        return moment(left.endDate).unix() - moment(right.endDate).unix();
      });

      return (
        <div className="profile-rewards-list">
          <Helmet>
            <title>Rewards</title>
          </Helmet>
          <div className="reward-grid">
            <div className="reward-row reward-header">
              <div className="reward-offer">Offer</div>
              <div className="reward-desc">Description</div>
              <div className="reward-dates">
                <div className="reward-starts">Starts</div>
                <div className="reward-ends">Ends</div>
              </div>
            </div>
            <div className="reward-scrollbox">
              {sortedRewards.map(this.renderReward)}
            </div>
          </div>
        </div>
      );
    }
  } // render()
} //class ProfileRewardsList

ProfileRewardsList.propTypes = {
  data: PropTypes.shape({
    rewards: PropTypes.arrayOf(
      PropTypes.shape({
        prizeType: PropTypes.string,
        prizeName: PropTypes.string,
        startDate: PropTypes.string,
        endDate: PropTypes.string
      })
    )
  }),
  loading: PropTypes.bool,
  error: PropTypes.oneOfType([
    PropTypes.instanceOf(ApolloError),
    PropTypes.instanceOf(Error),
    PropTypes.bool
  ])
};

const patronOffersQuery = gql`
  query {
    rewards {
      prizeType
      prizeName
      startDate
      endDate
    }
  }
`;

const ProfileRewardsListWithData = graphql(patronOffersQuery)(
  ProfileRewardsList
);

export default ProfileRewardsListWithData;



// WEBPACK FOOTER //
// ./src/containers/ProfilePage/ProfileRewardsList/index.js